/* Go Damn - product page behaviour */
(function () {
  try { document.documentElement.classList.add('gd-js'); } catch (e) {}
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function reveal() {
    var els = document.querySelectorAll('.gd-rev:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      each(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    each(els, function (el) { io.observe(el); });
    /* safety net: anything already on screen is shown even if the observer is late */
    setTimeout(function () {
      each(document.querySelectorAll('.gd-rev:not(.is-in)'), function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('is-in');
      });
    }, 1200);
  }

  function accordions() {
    /* "open first row" is a desktop nicety: on phones it would push the page far down */
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
      each(document.querySelectorAll('.gd-acc__i[data-open-first]'), function (item) {
        item.removeAttribute('data-open-first');
        item.classList.remove('is-open');
        var h = item.querySelector('.gd-acc__h');
        if (h) h.setAttribute('aria-expanded', 'false');
      });
    }
    each(document.querySelectorAll('.gd-acc__h'), function (btn) {
      if (btn.dataset.gdBound) return;
      btn.dataset.gdBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.gd-acc__i');
        if (!item) return;
        var isOpen = item.classList.contains('is-open');
        var wrap = item.parentElement;
        if (wrap && wrap.dataset.single === '1') {
          each(wrap.querySelectorAll('.gd-acc__i.is-open'), function (o) {
            o.classList.remove('is-open');
            var h = o.querySelector('.gd-acc__h');
            if (h) h.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  function pincode() {
    each(document.querySelectorAll('.gd-pin'), function (w) {
      if (w.dataset.gdBound) return;
      w.dataset.gdBound = '1';
      var input = w.querySelector('input');
      var btn = w.querySelector('button');
      var msg = w.querySelector('.gd-pin__msg');
      if (!input || !btn || !msg) return;
      function check() {
        var v = (input.value || '').trim();
        if (!/^[1-9][0-9]{5}$/.test(v)) {
          msg.textContent = w.dataset.invalid || 'Please enter a valid 6-digit pincode.';
          msg.setAttribute('data-ok', '0');
          return;
        }
        msg.textContent = (w.dataset.success || 'Delivering to {pin}').split('{pin}').join(v);
        msg.setAttribute('data-ok', '1');
        try { localStorage.setItem('gd_pincode', v); } catch (e) {}
      }
      btn.addEventListener('click', check);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); check(); }
      });
      try {
        var saved = localStorage.getItem('gd_pincode');
        if (saved && !input.value) input.value = saved;
      } catch (e) {}
    });
  }

  /* Offer card: tap to copy the discount code */
  function offers() {
    each(document.querySelectorAll('.gd-offer__code'), function (btn) {
      if (btn.dataset.gdBound) return;
      btn.dataset.gdBound = '1';
      var act = btn.querySelector('.gd-offer__code-act');
      var offer = btn.closest('.gd-offer');
      var live = offer ? offer.querySelector('.gd-offer__live') : null;
      var label = act ? act.textContent : '';

      function done() {
        btn.classList.add('is-copied');
        if (act) act.textContent = act.getAttribute('data-copied') || 'Copied!';
        if (live) live.textContent = (btn.dataset.code || '') + ' copied';
        clearTimeout(btn._gdT);
        btn._gdT = setTimeout(function () {
          btn.classList.remove('is-copied');
          if (act) act.textContent = label;
          if (live) live.textContent = '';
        }, 2200);
      }

      function fallback() {
        try {
          var t = document.createElement('textarea');
          t.value = btn.dataset.code || '';
          t.setAttribute('readonly', '');
          t.style.position = 'fixed';
          t.style.top = '0';
          t.style.opacity = '0';
          document.body.appendChild(t);
          t.select();
          document.execCommand('copy');
          document.body.removeChild(t);
        } catch (e) {}
        done();
      }

      btn.addEventListener('click', function () {
        var code = btn.dataset.code || '';
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, fallback);
        } else {
          fallback();
        }
      });
    });
  }

  /* Shade picker: preview the shade name on hover / keyboard focus */
  function shades() {
    each(document.querySelectorAll('.gd-shades'), function (w) {
      if (w.dataset.gdBound) return;
      w.dataset.gdBound = '1';
      var out = w.querySelector('.gd-shades__name');
      if (!out) return;
      var current = out.textContent;
      each(w.querySelectorAll('.gd-swatch'), function (a) {
        function show() { out.textContent = a.getAttribute('data-name') || current; }
        function reset() { out.textContent = current; }
        a.addEventListener('mouseenter', show);
        a.addEventListener('focus', show);
        a.addEventListener('mouseleave', reset);
        a.addEventListener('blur', reset);
      });
    });
  }

  function init() { reveal(); accordions(); pincode(); offers(); shades(); }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
  document.addEventListener('variant:update', init);
})();
